// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/announcements.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AnnouncementDisplayTypeEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/announcements.proto.
 */
export const file_cortado_v1_announcements: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_cortado_v1_settings, file_cortado_v1_users]);

/**
 * @generated from message cortado.v1.Announcement
 */
export type Announcement = Message<"cortado.v1.Announcement"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 20;
   */
  title: string;

  /**
   * @generated from field: string body = 21;
   */
  body: string;

  /**
   * @generated from field: optional string action_url = 22;
   */
  actionUrl?: string;

  /**
   * @generated from field: cortado.v1.AnnouncementDisplayTypeEnum display_type = 23;
   */
  displayType: AnnouncementDisplayTypeEnum;

  /**
   * @generated from field: optional string primary_button_label = 24;
   */
  primaryButtonLabel?: string;

  /**
   * @generated from field: optional string primary_button_value = 25;
   */
  primaryButtonValue?: string;

  /**
   * @generated from field: optional string secondary_button_label = 26;
   */
  secondaryButtonLabel?: string;

  /**
   * @generated from field: optional string secondary_button_value = 27;
   */
  secondaryButtonValue?: string;

  /**
   * Public GCS URL for the announcement's header image. Set by the backend
   * after a successful upload during Create; clients display this directly.
   *
   * @generated from field: optional string header_image_url = 28;
   */
  headerImageUrl?: string;

  /**
   * Short label rendered alongside the announcement (e.g. "Private Beta",
   * "New"). Purely cosmetic — no behavioral meaning.
   *
   * @generated from field: optional string tag = 29;
   */
  tag?: string;

  /**
   * @generated from field: google.protobuf.Timestamp published_at = 60;
   */
  publishedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 61;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string created_by = 62;
   */
  createdBy: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 63;
   */
  archivedAt?: Timestamp;

  /**
   * @generated from field: optional string archived_by = 64;
   */
  archivedBy?: string;
};

/**
 * Describes the message cortado.v1.Announcement.
 * Use `create(AnnouncementSchema)` to create a new message.
 */
export const AnnouncementSchema: GenMessage<Announcement> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 0);

/**
 * @generated from message cortado.v1.CreateAnnouncementRequest
 */
export type CreateAnnouncementRequest = Message<"cortado.v1.CreateAnnouncementRequest"> & {
  /**
   * @generated from field: string title = 20;
   */
  title: string;

  /**
   * @generated from field: string body = 21;
   */
  body: string;

  /**
   * @generated from field: optional string action_url = 22;
   */
  actionUrl?: string;

  /**
   * @generated from field: cortado.v1.AnnouncementDisplayTypeEnum display_type = 23;
   */
  displayType: AnnouncementDisplayTypeEnum;

  /**
   * @generated from field: optional string primary_button_label = 24;
   */
  primaryButtonLabel?: string;

  /**
   * @generated from field: optional string primary_button_value = 25;
   */
  primaryButtonValue?: string;

  /**
   * @generated from field: optional string secondary_button_label = 26;
   */
  secondaryButtonLabel?: string;

  /**
   * @generated from field: optional string secondary_button_value = 27;
   */
  secondaryButtonValue?: string;

  /**
   * Reserved for future use. The backend currently derives the header image
   * URL from `header_image_base64` during Create and ignores this field.
   *
   * @generated from field: optional string header_image_url = 28;
   */
  headerImageUrl?: string;

  /**
   * Short label rendered alongside the announcement (e.g. "Private Beta").
   *
   * @generated from field: optional string tag = 29;
   */
  tag?: string;

  /**
   * Raw image bytes (base64-encoded) the service uploads to GCS during
   * Create. The resulting public URL is stored on the Announcement as
   * `header_image_url`. Not persisted directly.
   *
   * @generated from field: optional string header_image_base64 = 30;
   */
  headerImageBase64?: string;
};

/**
 * Describes the message cortado.v1.CreateAnnouncementRequest.
 * Use `create(CreateAnnouncementRequestSchema)` to create a new message.
 */
export const CreateAnnouncementRequestSchema: GenMessage<CreateAnnouncementRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 1);

/**
 * @generated from message cortado.v1.CreateAnnouncementResponse
 */
export type CreateAnnouncementResponse = Message<"cortado.v1.CreateAnnouncementResponse"> & {
  /**
   * @generated from field: cortado.v1.Announcement announcement = 1;
   */
  announcement?: Announcement;
};

/**
 * Describes the message cortado.v1.CreateAnnouncementResponse.
 * Use `create(CreateAnnouncementResponseSchema)` to create a new message.
 */
export const CreateAnnouncementResponseSchema: GenMessage<CreateAnnouncementResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 2);

/**
 * @generated from message cortado.v1.ListAnnouncementsRequest
 */
export type ListAnnouncementsRequest = Message<"cortado.v1.ListAnnouncementsRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 2;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListAnnouncementsRequest.
 * Use `create(ListAnnouncementsRequestSchema)` to create a new message.
 */
export const ListAnnouncementsRequestSchema: GenMessage<ListAnnouncementsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 3);

/**
 * @generated from message cortado.v1.ListAnnouncementsResponse
 */
export type ListAnnouncementsResponse = Message<"cortado.v1.ListAnnouncementsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Announcement announcements = 1;
   */
  announcements: Announcement[];
};

/**
 * Describes the message cortado.v1.ListAnnouncementsResponse.
 * Use `create(ListAnnouncementsResponseSchema)` to create a new message.
 */
export const ListAnnouncementsResponseSchema: GenMessage<ListAnnouncementsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 4);

/**
 * @generated from message cortado.v1.AnnouncementRead
 */
export type AnnouncementRead = Message<"cortado.v1.AnnouncementRead"> & {
  /**
   * @generated from field: cortado.v1.User user = 1;
   */
  user?: User;

  /**
   * @generated from field: google.protobuf.Timestamp read_at = 2;
   */
  readAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.AnnouncementRead.
 * Use `create(AnnouncementReadSchema)` to create a new message.
 */
export const AnnouncementReadSchema: GenMessage<AnnouncementRead> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 5);

/**
 * @generated from message cortado.v1.ListAnnouncementReadsRequest
 */
export type ListAnnouncementReadsRequest = Message<"cortado.v1.ListAnnouncementReadsRequest"> & {
  /**
   * @generated from field: string announcement_id = 1;
   */
  announcementId: string;

  /**
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListAnnouncementReadsRequest.
 * Use `create(ListAnnouncementReadsRequestSchema)` to create a new message.
 */
export const ListAnnouncementReadsRequestSchema: GenMessage<ListAnnouncementReadsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 6);

/**
 * @generated from message cortado.v1.ListAnnouncementReadsResponse
 */
export type ListAnnouncementReadsResponse = Message<"cortado.v1.ListAnnouncementReadsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.AnnouncementRead reads = 1;
   */
  reads: AnnouncementRead[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message cortado.v1.ListAnnouncementReadsResponse.
 * Use `create(ListAnnouncementReadsResponseSchema)` to create a new message.
 */
export const ListAnnouncementReadsResponseSchema: GenMessage<ListAnnouncementReadsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 7);

/**
 * @generated from message cortado.v1.ListUnreadAnnouncementsRequest
 */
export type ListUnreadAnnouncementsRequest = Message<"cortado.v1.ListUnreadAnnouncementsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: optional int32 limit = 10;
   */
  limit?: number;

  /**
   * @generated from field: optional int32 offset = 11;
   */
  offset?: number;
};

/**
 * Describes the message cortado.v1.ListUnreadAnnouncementsRequest.
 * Use `create(ListUnreadAnnouncementsRequestSchema)` to create a new message.
 */
export const ListUnreadAnnouncementsRequestSchema: GenMessage<ListUnreadAnnouncementsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 8);

/**
 * @generated from message cortado.v1.ListUnreadAnnouncementsResponse
 */
export type ListUnreadAnnouncementsResponse = Message<"cortado.v1.ListUnreadAnnouncementsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.Announcement announcements = 1;
   */
  announcements: Announcement[];
};

/**
 * Describes the message cortado.v1.ListUnreadAnnouncementsResponse.
 * Use `create(ListUnreadAnnouncementsResponseSchema)` to create a new message.
 */
export const ListUnreadAnnouncementsResponseSchema: GenMessage<ListUnreadAnnouncementsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 9);

/**
 * @generated from message cortado.v1.MarkAnnouncementReadRequest
 */
export type MarkAnnouncementReadRequest = Message<"cortado.v1.MarkAnnouncementReadRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string announcement_id = 2;
   */
  announcementId: string;
};

/**
 * Describes the message cortado.v1.MarkAnnouncementReadRequest.
 * Use `create(MarkAnnouncementReadRequestSchema)` to create a new message.
 */
export const MarkAnnouncementReadRequestSchema: GenMessage<MarkAnnouncementReadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 10);

/**
 * @generated from message cortado.v1.MarkAnnouncementReadResponse
 */
export type MarkAnnouncementReadResponse = Message<"cortado.v1.MarkAnnouncementReadResponse"> & {
};

/**
 * Describes the message cortado.v1.MarkAnnouncementReadResponse.
 * Use `create(MarkAnnouncementReadResponseSchema)` to create a new message.
 */
export const MarkAnnouncementReadResponseSchema: GenMessage<MarkAnnouncementReadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 11);

/**
 * @generated from message cortado.v1.ArchiveAnnouncementRequest
 */
export type ArchiveAnnouncementRequest = Message<"cortado.v1.ArchiveAnnouncementRequest"> & {
  /**
   * @generated from field: string announcement_id = 1;
   */
  announcementId: string;
};

/**
 * Describes the message cortado.v1.ArchiveAnnouncementRequest.
 * Use `create(ArchiveAnnouncementRequestSchema)` to create a new message.
 */
export const ArchiveAnnouncementRequestSchema: GenMessage<ArchiveAnnouncementRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 12);

/**
 * @generated from message cortado.v1.ArchiveAnnouncementResponse
 */
export type ArchiveAnnouncementResponse = Message<"cortado.v1.ArchiveAnnouncementResponse"> & {
  /**
   * @generated from field: cortado.v1.Announcement announcement = 1;
   */
  announcement?: Announcement;
};

/**
 * Describes the message cortado.v1.ArchiveAnnouncementResponse.
 * Use `create(ArchiveAnnouncementResponseSchema)` to create a new message.
 */
export const ArchiveAnnouncementResponseSchema: GenMessage<ArchiveAnnouncementResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_announcements, 13);

